// @flow

import * as React from 'react';
import {useEffect} from 'react';
import classNames from 'classnames';

import Box from 'sail/Box';
import type {BackgroundColor} from 'sail/Box/types';
import {useSidebar} from 'docs/data';

import './SidebarContainer.scss';

type SidebarContainerProps = {|
  background: BackgroundColor,
  children: React.Node,
|};

export const SidebarContainer = ({
  background,
  children,
}: SidebarContainerProps) => {
  const {setOpen} = useSidebar();

  useEffect(() => {
    const handle = (event) => {
      // Easter egg shortcut to let folks toggle the sidebar with cmd+\
      if (event.metaKey && event.keyCode === 220) {
        setOpen((open) => !open);
      }
    };
    window.addEventListener('keydown', handle);
    return () => {
      window.removeEventListener('keydown', handle);
    };
  }, [setOpen]);

  return (
    <Box
      background={background}
      divider={{color: 'light', width: 1, side: 'right'}}
      flex={{direction: 'column'}}
      flexGrow={0}
      flexShrink={0}
      className={classNames('SidebarContainer')}
    >
      {children}
    </Box>
  );
};
